var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferCopy(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0228577,
    width: 40,
    height: 40,
    rx: 4,
    fill: "#E7EFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5708 10H17.475C15.5717 10 14.0229 11.5488 14.0229 13.4521V14H13.475C11.5717 14 10.0229 15.5488 10.0229 17.4521V26.5478C10.0229 28.4512 11.5717 30 13.475 30H22.5707C24.3192 30 25.7529 28.6882 25.9771 27H26.5707C28.4741 27 30.0229 25.4512 30.0229 23.5479V13.4521C30.0229 11.5488 28.4741 10 26.5708 10ZM28.0229 23.5479C28.0229 24.3486 27.3715 25 26.5708 25H26.0229V17.4521C26.0229 15.5488 24.4741 14 22.5708 14H16.0229V13.4521C16.0229 12.6514 16.6743 12 17.475 12H26.5707C27.3715 12 28.0229 12.6514 28.0229 13.4521V23.5479Z",
    fill: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferCopy);
export default __webpack_public_path__ + "static/media/ReferCopy.6cc2e5e3e103d2f4c16ffa083a16c094.svg";
export { ForwardRef as ReactComponent };